var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.7952 17.5C8.38279 18.0187 9.15471 18.3334 10 18.3334C10.8455 18.3334 11.6173 18.0187 12.2049 17.5M10.8334 1.7366C10.5598 1.69036 10.2811 1.66669 10 1.66669C8.67396 1.66669 7.40221 2.19347 6.46453 3.13115C5.52684 4.06884 5.00006 5.3406 5.00006 6.66669C5.00006 9.24185 4.35045 11.005 3.62478 12.1712C3.01267 13.1549 2.70661 13.6468 2.71783 13.784C2.73026 13.9359 2.76244 13.9939 2.88487 14.0847C2.99544 14.1667 3.49388 14.1667 4.49077 14.1667H15.5094C16.5062 14.1667 17.0046 14.1667 17.1152 14.0847C17.2376 13.9939 17.2698 13.9359 17.2822 13.784C17.2935 13.6468 16.9874 13.1549 16.3752 12.171C15.9652 11.512 15.5795 10.6624 15.3215 9.58335",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 15.3334,
    cy: 4.66667,
    r: 2.66667,
    fill: "#EE0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationaction);
export default __webpack_public_path__ + "static/media/notificationaction.dbed99c3d858e0eb518bcd022da962b2.svg";
export { ForwardRef as ReactComponent };